import { keyframes, styled, Box, BoxProps } from '@mui/material';
import { BadgeColors } from './PulsingBadge.types';

export const radialPulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  100% {
    transform: scale(2.5);
    opacity: 0;
  }
`;

export const StyledPulsingBadgeContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'showBullet'
})<BoxProps & { showBullet?: boolean }>(({ theme, showBullet = false }) => ({
  position: 'absolute',
  width: showBullet ? '10px' : '12px',
  height: showBullet ? '10px' : '12px',
  top: showBullet ? 0 : theme.spacing(-1),
  right: showBullet ? 0 : theme.spacing(-1),
  pointerEvents: 'none'
}));

export const StyledInnerDot = styled(Box, {
  shouldForwardProp: (prop: string) => !['color', 'showBullet'].includes(prop)
})<BoxProps & { color: BadgeColors; showBullet?: boolean }>(
  ({ theme, color, showBullet = false }) => ({
    width: showBullet ? '10px' : '20px',
    height: showBullet ? '10px' : '20px',
    backgroundColor: theme.palette[color].main,
    borderRadius: '50%',
    position: 'absolute',
    color: theme.palette.common.white,
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: 0,
    left: 0,
    zIndex: 2
  })
);

export const StyledPulsingRing = styled(Box, {
  shouldForwardProp: (prop: string) =>
    !['color', 'showBullet', 'pulseAnimation'].includes(prop)
})<
  BoxProps & {
    color: BadgeColors;
    showBullet?: boolean;
    pulseAnimation?: boolean;
  }
>(({ theme, color, showBullet = false, pulseAnimation = false }) => ({
  width: showBullet ? '10px' : '20px',
  height: showBullet ? '10px' : '20px',
  borderRadius: '50%',
  backgroundColor: theme.palette[color].main,
  opacity: 0.6,
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1,
  ...(pulseAnimation && {
    animation: `${radialPulse} 1.5s ease-out infinite`
  })
}));
